import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";

export const selectionAssistantPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.selectionAssistant(),
    queryFn: () => fetchOccPageData<PageInitialDataResult<void>>("/page-data/selectionassistant"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
